if (!window.Eurus.loadedScript.has('product-sibling.js')) {
  window.Eurus.loadedScript.add('product-sibling.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductSibling", (sectionId, isProductPage, redirect) => ({
        cachedResults: [],

        init() {
          document.addEventListener('change', (e) => {
            if (!e.target.closest('#variant-update-' + sectionId)) return;
            this.filterBySelectedOptions();
          });

          this.$nextTick(() => this.filterBySelectedOptions());
        },

        getSelectedOptions() {
          const selected = {};
          const variantUpdate = document.getElementById('variant-update-' + sectionId);
          if (!variantUpdate) return selected;

          variantUpdate.querySelectorAll('select[id^="Option-"]').forEach(sel => {
            const wrapper = sel.closest('[data-option-name]');
            if (wrapper && sel.value) {
              selected[wrapper.dataset.optionName] = sel.value.toLowerCase();
            }
          });

          variantUpdate.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
            const fieldset = radio.closest('[data-option-name]');
            if (fieldset && radio.value) {
              selected[fieldset.dataset.optionName] = radio.value.toLowerCase();
            }
          });

          return selected;
        },

        filterBySelectedOptions() {
          const selectedOptions = this.getSelectedOptions();
          if (!Object.keys(selectedOptions).length) return;

          this.$el.querySelectorAll('.sibling-product-wrapper').forEach(wrapper => {
            let siblingOpts = {};
            try { siblingOpts = JSON.parse(wrapper.dataset.siblingOptions || '{}'); } catch (e) {}

            const shouldShow = Object.entries(selectedOptions).every(([optName, optValue]) => {
              if (!siblingOpts[optName]) return true;
              return siblingOpts[optName].includes(optValue);
            });

            wrapper.style.display = shouldShow ? '' : 'none';
          });

          this.$el.querySelectorAll('select option[data-sibling-options]').forEach(opt => {
            let siblingOpts = {};
            try { siblingOpts = JSON.parse(opt.dataset.siblingOptions || '{}'); } catch (e) {}

            const shouldShow = Object.entries(selectedOptions).every(([optName, optValue]) => {
              if (!siblingOpts[optName]) return true;
              return siblingOpts[optName].includes(optValue);
            });

            opt.disabled = !shouldShow;
            opt.hidden = !shouldShow;

            if (!shouldShow && opt.selected) {
              const firstVisible = opt.parentElement.querySelector('option:not([disabled])');
              if (firstVisible) firstVisible.selected = true;
            }
          });
        },

        updateProductInfo(url) {
          if (redirect) {
            window.location.href = url;
            return;
          }
          const link = isProductPage ? `${url}` : `${url}?section_id=${sectionId}`;

          if (this.cachedResults[link]) {
            this._handleSwapProduct(this.cachedResults[link]);
          } else {
            fetch(link)
              .then(response => response.text())
              .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this._updateTitle(html);
                this._handleSwapProduct(html);
                this._updateFbtContainer(html);
                this.cachedResults[link] = html;
              });
          }
          this._updateURL(url);
        },

        changeSelectOption(event) {
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          this.updateProductInfo(targetUrl);
        },

        _updateURL(url) {
          if (!isProductPage) return;
          window.history.replaceState({}, '', `${url}`);
        },

        _updateTitle(html) {
          if (!isProductPage) return;
          document.querySelector('head title').textContent = html.querySelector('.product-title').textContent;
          const destination = document.querySelector('#breadcrumbs--' + sectionId);
          const source = html.querySelector('#breadcrumbs--' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },

        _updateFbtContainer(html) {
          if (!isProductPage) return;
          const destination = document.querySelector('#popup-fbt-' + sectionId);
          const source = html.querySelector('#popup-fbt-' + sectionId);
          if (source && destination) destination.outerHTML = source.outerHTML;
        },

        _handleSwapProduct(html) {
          const destination = isProductPage
            ? document.querySelector('.main-product')
            : document.querySelector('.x-product-' + sectionId);
          const source = isProductPage
            ? html.querySelector('.main-product')
            : html.querySelector('.x-product-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      }));
    });
  });
}
